import { createSelector } from 'reselect'
import { SettingsRootState } from '../root.reducer'

export const getPrefersDarkMode = createSelector(
  (state: SettingsRootState) => state.settingsStore.prefersDarkMode,
  (state) => state,
)

export const getTheme = createSelector(
  (state: SettingsRootState) => state.settingsStore.theme,
  (state) => state,
)

export const getMessage = createSelector(
  (state: SettingsRootState) => state.settingsStore.message,
  (state) => state,
)

export const getSearchInput = createSelector(
  (state: SettingsRootState) => state.settingsStore.searchInput,
  (state) => state,
)

export const getUser = createSelector(
  (state: SettingsRootState) => state.settingsStore.user,
  (state) => state,
)

export const getActiveMember = createSelector(
  (state: SettingsRootState) => state.settingsStore.activeMember,
  (state) => state,
)

export const getUserPermissions = createSelector(
  (state: SettingsRootState) => state.settingsStore.userPermissions,
  (state) => state,
)
export const getNavPoint = createSelector(
  (state: SettingsRootState) => state.settingsStore.navPoint,
  (state) => state,
)
export const getBiography = createSelector(
  (state: SettingsRootState) => state.settingsStore.biography,
  (state) => state,
)
export const getGeography = createSelector(
  (state: SettingsRootState) => state.settingsStore.geography,
  (state) => state,
)
export const getRedirectPath = createSelector(
  (state: SettingsRootState) => state.settingsStore.redirectPath,
  (state) => state,
)
